import React from "react";
import { Row, Col } from "react-bootstrap";
import logoJM from "../../../components/logo-jm2.png";

export default function HomeFooter() {
  return (
    <footer className="home-footer">
      <Row className="justify-content-center text-center">
        <Col xs={12}>
          <img src={logoJM} alt="Logo J. Martins" className="footer-logo" />
        </Col>
        <Col xs={12} className="mt-2">
          <span className="footer-text">
            Desenvolvido por <strong>Cabo PM J. Martins</strong>
          </span>
        </Col>
      </Row>
    </footer>
  );
}
